<template>
  <AttrBase v-slot="{ hover }" :label="label">
    <a-input-number
      v-if="typeof _value === 'string'"
      :value="_value"
      :bordered="false"
      :controls="false"
      class="text-base font-medium !border border-transparent transition-all"
      :class="{
        underline: underline
      }"
      :style="{
        width: width + 'px',
        borderColor: hover && !readonly && !disabled ? '#838383' : '',
        borderStyle: '1px solid'
      }"
      :readonly="readonly"
      :disabled="disabled"
      @change="(val:number) => emit('change',val)"
    >
      <template v-if="addonAfter" #addonAfter>
        <span>{{ addonAfter }}</span>
      </template>
    </a-input-number>
    <a-time-picker
      v-else
      label=""
      format="HH:mm"
      :width="64"
      :bordered="false"
      :allow-clear="false"
      :show-now="false"
      :readonly="readonly"
      :disabled="disabled"
      popup-class-name="data-source-time-picker"
      class="text-base font-medium !border border-transparent transition-all"
      :class="{
        underline: underline
      }"
      :style="{
        width: width + 'px',
        borderColor: hover && !readonly && !disabled ? '#838383' : '',
        borderStyle: '1px solid'
      }"
      :value="_value"
      @change="(val:dayjs.Dayjs)=>emit('change', val.hour() + val.minute() / 60)"
      ><template #suffixIcon
        ><span>{{ addonAfter }}</span></template
      ></a-time-picker
    >
    <slot />
  </AttrBase>
</template>
<script lang="ts" setup>
import { getPrecisionValue } from '@/utils/number';
import dayjs from 'dayjs';
import { ref, watch } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  value: {
    type: [Number, String],
    default: undefined
  },
  addonAfter: {
    type: String,
    default: undefined
  },
  disabled: {
    type: Boolean,
    default: undefined
  },
  readonly: {
    type: Boolean,
    default: undefined
  },
  underline: {
    type: Boolean,
    default: undefined
  },
  width: {
    type: Number,
    default: 64
  }
});

const _value = ref<string | dayjs.Dayjs>();
watch(
  () => props.value,
  (val) => {
    if (val !== undefined && typeof val !== 'string') {
      _value.value = dayjs('2022-08-16 00:00')
        .second(0)
        .hour(Math.floor(val as number))
        .minute(getPrecisionValue(val as number) * 60);
    } else _value.value = val;
  },
  { immediate: true }
);

const emit = defineEmits<{
  (event: 'change', val: number): void;
}>();
</script>

<style lang="less" scoped>
:deep(.ant-input-number-input) {
  text-align: end;
  padding-right: 1px;
}
:deep(.ant-input-number-group-addon) {
  padding: 0;
  border: none;
  font-size: 0.875rem;
}
:deep(.ant-input-number) {
  &:focus,
  &:hover {
    border-color: #838383;
  }
}
.underline :deep(input) {
  text-decoration: underline !important;
}
:deep(input) {
  text-align: right;
}
</style>
<style lang="less">
.data-source-time-picker .ant-picker-footer .ant-btn {
  width: 48px;
  height: 24px;
  padding: 0px 7px;
  font-size: 14px;
  border-radius: 2px;
}
</style>
